import React from 'react';
import { createRoot } from 'react-dom/client';

import '../../style-sheet-helpers-migrated.css';
import '../../index-global.less';
import './index.less';
import ForgotPasswordForm from './forgot-password-form';
import AuthPageProvider from '../auth-page-provider';

const RenderForgotPasswordForm = () => (
  <AuthPageProvider>
    <ForgotPasswordForm />
  </AuthPageProvider>
);

const root = createRoot(document.getElementById('forgot-password-form-wrapper'));
root.render(<RenderForgotPasswordForm />);
